import { Link } from 'react-router-dom'
import { Company, User } from '../../types/ffe'
import { Button } from 'antd'

export const upgradeButtonRedirect = (user?: User | null) => {
  return user?.isDemo ? '/signup?redirect=/app/upgrade' : '/app/upgrade'
}

export const UpgradeButton: React.FC<{
  company: Company
  user?: User | null
}> = ({ company, user }) => {
  if (company.plan !== 'free') {
    return <></>
  }

  return (
    <Link className="flex" to={upgradeButtonRedirect(user)}>
      <Button type="primary">Upgrade Now</Button>
    </Link>
  )
}
